<template>
  <GeneralDashboardLayout>
      <template v-slot:header>
          <div class="header-template">
              <back-button :to="{ name: 'dashboard.index' }"/>
              <h1>Event Hall </h1>
                <div>
                    <button class="btn btn-outline-light" @click="submitForm">Save Changes</button>
                    &nbsp;  <button class="btn btn-outline-light" @click="cancelEdit">Cancel</button>
                </div>



          </div>
      </template>
      <template v-slot:content>
          <div id="assets_content">
              <div class="fluid-container demo agenda_content">
                  <div class="row no_lm">
                      <div class="col-lg-12">
                          <div class="kt-portlet">
                                  <div class="kt-portlet__body">
                                      <input
                                        type="hidden"
                                        class="form-control"
                                        name="event_id"
                                        placeholder="Event Id"
                                        :value="item.event_id"
                                      />
                                      <tabs :options="{ useUrlFragment: false, defaultTabHash: 'theme-contents' }">
                                          <tab name="Theme Contents" :selected="true">
                                              <ThemeContentsTab />
                                          </tab>
                                          <tab name="Flags" >
                                            <FlagsTab/>
                                          </tab>
                                          <tab name="Banners">
                                            <BannersTab/>
                                          </tab>
                                          <tab name="Video Screens" >
                                            <VideoScreensTab/>
                                          </tab>
                                          <tab name="3D Model" >
                                            <ModelTab/>
                                          </tab>
                                        </tabs>
                                    </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <FlashMessage group="event_hall_index" />

      </template>
   
  </GeneralDashboardLayout>
</template>


<script>
import GeneralDashboardLayout from "@/components/layouts/GeneralDashboardLayout";
import {mapActions, mapGetters} from "vuex";
import BannersTab       from "@/components/cruds/EventHalls/Tabs/BannersTab";
import FlagsTab         from "@/components/cruds/EventHalls/Tabs/FlagsTab";
import ThemeContentsTab from "@/components/cruds/EventHalls/Tabs/ThemeContentsTab";
import VideoScreensTab  from "@/components/cruds/EventHalls/Tabs/VideoScreensTab";
import  ModelTab        from "@/components/cruds/EventHalls/Tabs/3DModelTab";
import { gettingErrorMessage } from "@/services/GetValidationMessage";
import BackButton from "@/components/Commons/BackButton";

export default {
  name: 'EventHallsEdit',
  components: {
      BannersTab,
      VideoScreensTab,
      ThemeContentsTab,
      FlagsTab,
      BackButton,
      GeneralDashboardLayout,
      ModelTab
  },
  data() {
      return {
          event_theme: null,
      };
  },
  computed: {
      ...mapGetters("EventHallsSingle", [
          "item",
          "loading"
         
      ])
  },
  async created() {
    console.log("this.$route.params==>",this.$route.params);
    await this.fetchData(this.$route.params);
    this.setEvent(this.$route.params.event_id);
  },
  beforeUnmount() {
    this.resetState();
    delete this.$flashMessage.groups.event_hall_index;
  },
 
  watch: {
      
  },
  methods: {
      ...mapActions("EventHallsSingle", [
          "fetchData",
          "updateData",
          "resetState",
          "setEvent"
      ]),
      cancelEdit() {
        this.$router.back()
      },
      submitForm() {
        this.updateData()
        .then(() => {
          
           this.$flashMessage.show({
               group  : 'event_hall_index',
               type   : 'success',
               title  : 'Success',
               time   : 1000,
               html   : '<ul><li>Event Hall has been updated successfully.</li></ul>'
             });
             this.resetState()
             setTimeout(() =>  this.$router.push({ name: "event_dashboard.index"}), 2000);
        })
        .catch(error => {
          let html =  gettingErrorMessage(error);
            console.log("Error Event Event HAll Area",html)
            if (error.response.data.data.error) {
                this.$flashMessage.show({
                    group: 'event_hall_index',
                    type: 'error',
                    title: 'Failed',
                    text: html || 'Something went wrong',
                    html: html
                });
            }
        });
         
      }
  }
};
</script>


<style>
.eventhall_flags .col-lg-4 {
  display: inline-block !important;
  margin-bottom: 50px;
  float: left;
  height: 100px;
}

label {
  display: inline;
}
.image-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 250px!important;
}

.image-item {
  display: flex;
  align-items: center;
  gap: 15px;
  background-color: #fff;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 250px!important;
}

.image-item img {
  width: 100px !important;
  height: 60px !important;
  object-fit: cover;
  border-radius: 5px;
}

.image-details {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.image-name {
  font-size: 14px;
  font-weight: bold;
  color: #333;
}

.remove-btn {
  padding: 5px 10px;
  font-size: 14px;
  color: #fff;
  background-color: #e74c3c;
  border: none;
  border-radius: 3px;
  cursor: pointer;
}

.remove-btn:hover {
  background-color: #c0392b;
}

    .event_detail_wrapper {
        border-bottom: 0px solid #ccc;
        padding: 10px 0px;
    
        .event_ls_label {
            font-weight: bold;
        }
    }
    
    .setting_wrapper {
        float: right;
    
        a {
            color: #201e1eba;
            padding: 9px;
            margin-left: 5px;
            background: #c0cdd345;
            border-radius: 4px;
            border: 1px solid #80808054;
        }
    }
    
    .toggle label {
        color: #000 !important;
    }
    
    .drop-files {
        margin-top: 10px;
    }
    
    .newspeaker {
        margin-top: 20px;
    }
    
    .newspeaker button {
        width: 100%;
    }
    
    .add_spk_btn {
        background-color: #0088CC;
        color: #fff;
    }
    
    .mini_txt {
        font-size: 0.8em;
        color: #585252;
        font-style: italic;
        margin-bottom: 10px;
    }
    
    .v-dialog>.v-overlay__content>.v-card {
        border-radius: 15px;
        padding-top: 20px;
    }
    
    .tabs-left .nav-tabs>li .active {
        border-left-color: #0088CC;
    }
    
    .orangebtn {
        background-color: orange;
    }
    
    .wrapp {
        display: block;
        text-align: center;
        margin-bottom: 10px;
    }
    .flash-content {
        z-index: 10;
    }
    
    .dark{
      --popper-theme-text-color: #ffffff;
      --popper-theme-padding: 15px;
      --popper-theme-background-color: #333333;
      --popper-theme-border-radius: 6px;
      --popper-theme-box-shadow: 0 6px 30px -6px rgba(0, 0, 0, 0.25);
    }
    
    .tooltip_img img{    
        position: absolute;
        top: -53px;
        left: 50px;
        width: 300px;
        height: auto;
    }
</style>